webpackJsonp([9926713212879],{

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(6);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _articlePreviewModule = __webpack_require__(17);
	
	var _articlePreviewModule2 = _interopRequireDefault(_articlePreviewModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var program = _ref.program;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: '/program/' + program.slug },
	    _react2.default.createElement(
	      'div',
	      { className: _articlePreviewModule2.default.cardItem },
	      _react2.default.createElement(_gatsbyImage2.default, { alt: program.title, sizes: program.thumbnail.sizes, className: _articlePreviewModule2.default.cardImage }),
	      _react2.default.createElement(
	        'div',
	        { className: _articlePreviewModule2.default.cardInfo },
	        _react2.default.createElement(
	          'h3',
	          { className: _articlePreviewModule2.default.cardTitle },
	          program.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _articlePreviewModule2.default.cardExcerpt },
	          program.excerpt
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _articlePreviewModule2.default.cardCategory + ' label category' },
	          program.programCategory
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(8);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _blogModule = __webpack_require__(28);
	
	var _blogModule2 = _interopRequireDefault(_blogModule);
	
	var _programPreview = __webpack_require__(235);
	
	var _programPreview2 = _interopRequireDefault(_programPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookIndex = function (_React$Component) {
	  _inherits(BookIndex, _React$Component);
	
	  function BookIndex() {
	    _classCallCheck(this, BookIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BookIndex.prototype.render = function render() {
	
	    var siteData = (0, _get2.default)(this.props, 'data.site.siteMetadata');
	    var siteDescription = 'Kumpulan program-program YOUCAT Indonesia';
	    var posts = (0, _get2.default)(this, 'props.data.allContentfulProgram.edges');
	
	    return _react2.default.createElement(
	      'div',
	      { style: { background: '#fff' }, className: 'page-content' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: 'Program | ' + siteData.title },
	        _react2.default.createElement('link', { rel: 'canonical', href: siteData.siteUrl + '/program' }),
	        _react2.default.createElement('meta', { name: 'description', content: '' + siteDescription }),
	        _react2.default.createElement('meta', { name: 'title', content: 'Program | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Program | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: 'YOUCAT Indonesia' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: siteData.siteUrl + '/program' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: '' + siteDescription }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://static.youcat.id/ogimg/ogimg-youcat.png' }),
	        _react2.default.createElement('meta', { property: 'og:locale', content: 'id_ID' }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'website' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          'Program-program'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'program-list grid-x grid-padding-x grid-padding-y small-up-1 medium-up-2 large-up-3' },
	          posts.map(function (_ref) {
	            var node = _ref.node;
	
	            return _react2.default.createElement(
	              'li',
	              { key: node.slug, className: 'cell program-list-item' },
	              _react2.default.createElement(_programPreview2.default, { program: node })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return BookIndex;
	}(_react2.default.Component);
	
	exports.default = BookIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-program-js-c526045e0cc0af70b0fd.js